var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "custom-navbar-games-popup" }, [
    _setup.loading
      ? _c(
          "div",
          { staticClass: "loading-container" },
          [_c(_setup.VLoading)],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _setup.gameInfo
      ? _c("div", { staticClass: "custom-navbar-games-panel" }, [
          _c("div", { staticClass: "custom-navbar-games-left-panel" }, [
            _c(
              "a",
              {
                staticClass: "banner-game-card",
                attrs: {
                  href: _setup.gameInfo.banner.href,
                  title: _setup.gameInfo.banner.title,
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: _setup.gameInfo.banner.poster,
                    alt: _setup.gameInfo.banner.title,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "banner-game-card-title" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_setup.gameInfo.banner.title) +
                      "\n        "
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "panel-game-cards" },
              _vm._l(_setup.gameInfo.panel, function (card) {
                return _c(
                  "a",
                  {
                    key: card.href,
                    staticClass: "panel-game-card",
                    attrs: { href: card.href, title: card.title },
                  },
                  [
                    _c("img", { attrs: { src: card.poster, alt: card.title } }),
                    _vm._v(" "),
                    _c("div", { staticClass: "panel-game-card-title" }, [
                      _vm._v(
                        "\n            " + _vm._s(card.title) + "\n          "
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "custom-navbar-games-panel-separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "custom-navbar-games-right-panel" }, [
            _c("div", { staticClass: "list-game-cards-title" }, [
              _vm._v("新游预告"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "list-game-cards" },
              _vm._l(_setup.gameInfo.list.slice(0, 8), function (card) {
                return _c(
                  "a",
                  {
                    key: card.href,
                    staticClass: "list-game-card",
                    attrs: { href: card.href, title: card.title },
                  },
                  [_vm._v("\n          " + _vm._s(card.title) + "\n        ")]
                )
              }),
              0
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }